import { Outlet } from 'react-router-dom';

export default function DashboardBlank() {

  return (
        <Outlet />
      
  );
}
